import { Vat } from '../vat';

export class VatBuilder {

  static fromJson(json): Vat {
    return (json) ? new Vat(
      json.defaultVat,
    ) : null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/vat.buildet.ts